var _path, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatching2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1056 0.447213C14.6686 0.165686 15.3314 0.165686 15.8944 0.447214L28.8944 6.94721C29.572 7.286 30 7.97852 30 8.73607V16.6667V24.5973C30 25.3548 29.572 26.0473 28.8944 26.3861L15.8944 32.8861C15.3314 33.1676 14.6686 33.1676 14.1056 32.8861L1.10557 26.3861C0.428004 26.0473 0 25.3548 0 24.5973V16.6667L0 8.73607C0 7.97852 0.428005 7.286 1.10557 6.94721L14.1056 0.447213Z",
    fill: "#B34B4B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2170_7859",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 9,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 9.16666,
    width: 15,
    height: 15,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2170_7859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 17.9167H14.375V16.0417H17.1875L16.25 14.7917L17.1875 13.5417H13.4375V17.9167ZM10.625 22.2917V12.2917C10.625 11.9479 10.7474 11.6536 10.9922 11.4088C11.237 11.1641 11.5313 11.0417 11.875 11.0417H18.125C18.4688 11.0417 18.763 11.1641 19.0078 11.4088C19.2526 11.6536 19.375 11.9479 19.375 12.2917V22.2917L15 20.4167L10.625 22.2917ZM11.875 20.3854L15 19.0417L18.125 20.3854V12.2917H11.875V20.3854Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatching2);
export default __webpack_public_path__ + "static/media/matching2.258c6614.svg";
export { ForwardRef as ReactComponent };